import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/custom.css";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config";

function Header() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/auth/check_session`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ CHECK SESSION:", data);
        if (data.status === "active") {
          setUser(data.user);
        }
      });
  }, []);

  const handleLogout = () => {
    fetch(`${API_BASE_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    }).then(() => {
      navigate("/");
    });
  };

  // const handleResetPassword = () => {
  //   navigate("/reset-password");
  // };

  const [showSearch, setShowSearch] = useState(false);
  const toggleSearch = () => setShowSearch(!showSearch);
  const [showDepartment, setShowDepartment] = useState(false);
  const toggleDepartment = () => setShowDepartment(!showDepartment);
  const [showMicroapps, setShowMicroapps] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const toggleProfile = () => setShowProfile(!showProfile);
  const toggleMicroapps = () => setShowMicroapps(!showMicroapps);
  const [searchTerm, setSearchTerm] = useState("");
  const [openDepartments, setOpenDepartments] = useState({});
  const departments = [
    {
      id: "crm",
      title: "CRM",
      icon: "fas fa-users",
      apps: [
        { id: "crm_add_lead", label: "Add Lead", link: "/pages/crm/addlead" },
        {
          id: "crm_view_lead",
          label: "View Lead",
          link: "/pages/crm/viewleads",
        },
        {
          id: "crm_edit_lead",
          label: "Edit Lead",
          link: "/pages/crm/editleads",
        },
      ],
    },
    {
      id: "invoicing",
      title: "Invoicing",
      icon: "fas fa-file-invoice",
      link: "/pages/invoicing/Invoicing",
      apps: [
        {
          id: "inv_create_pi",
          label: "Create Proforma",
          link: "/pages/invoicing/create-pi",
        },
        {
          id: "inv_view_pi",
          label: "View Proforma",
          link: "/pages/invoicing/view-pi",
        },
        {
          id: "inv_edit_pi",
          label: "Edit Proforma",
          link: "/pages/invoicing/edit-pi",
        },
        {
          id: "inv_create_tax_standalone",
          label: "Standalone Tax Invoice",
          link: "/pages/invoicing/create-tax-standalone",
        },
        {
          id: "inv_create_tax_from_pi",
          label: "Tax Invoice Against PI",
          link: "/pages/invoicing/create-tax-from-pi",
        },
        {
          id: "inv_view_tax",
          label: "View/Edit Tax Invoice",
          link: "/pages/invoicing/view-tax",
        },
      ],
    },

    {
  id: "settings",
  title: "Settings",
  icon: "fas fa-cog",
  link: "/pages/settings/Settings",
  apps: [
    { id: "settings_add_user", label: "Add User", link: "/pages/settings/AddUser" },
    { id: "settings_view_user", label: "View User", link: "/pages/settings/ViewUser" },
    { id: "settings_assign_microapp", label: "Assign Microapp", link: "/pages/settings/AssignMicroapp" },
    { id: "settings_billing_address", label: "Billing Address", link: "/pages/settings/BillingAddress" },
    { id: "settings_manage_brands", label: "Manage Brands", link: "/pages/settings/ManageBrands" },
  ],
}

  ];

  const assignedMicroapps =
    user?.role?.toLowerCase() === "superadmin"
      ? departments.flatMap((dept) => dept.apps.map((app) => app.id))
      : user?.assigned_microapps || [];

  const visibleDepartments = departments
    .map((dept) => {
      const visibleApps = dept.apps.filter((app) =>
        assignedMicroapps.includes(app.id),
      );
      if (visibleApps.length > 0) {
        return { ...dept, apps: visibleApps };
      }
      return null;
    })
    .filter(Boolean);

  React.useEffect(() => {
    const matches = departments.filter((dept) =>
      dept.apps.some((app) =>
        app.label.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );

    if (matches.length === 1) {
      setOpenDepartments({ [matches[0].id]: true });
    } else {
      const openAll = {};
      matches.forEach((m) => (openAll[m.id] = false));
      setOpenDepartments(openAll);
    }
  }, [searchTerm]);

  const handleGlobalSearch = () => {
  const hasAccess =
    user?.role?.toLowerCase() === "superadmin" ||
    assignedMicroapps.includes("crm_view_lead");

  if (!hasAccess) {
    alert("You don’t have access to search leads.");
    return;
  }

  const sanitized = searchTerm.trim().replace(/\s+/g, " ");
  if (sanitized.length < 2) {
    alert("Please enter at least 2 characters to search.");
    return;
  }

  navigate(`/pages/crm/viewleads?search=${encodeURIComponent(sanitized)}`);
};


  return (
    <>
      {/* ✅ Top Header (Logo + Profile Only on Mobile) */}
      <div
        className="d-flex justify-content-between align-items-center p-3 border-bottom bg-white shadow-sm"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1045,
          height: "75px",
          padding: "15px",
        }}
      >
        {/* Logo */}
        <div>
          <Link to="/home">
            <img
              src="/assets/logos/webyappy.png"
              alt="Webyappy"
              style={{ height: 30 }}
            />
          </Link>
        </div>

        {/* Right Icons */}
        <div className="d-none d-md-flex align-items-center">
          {/* Search */}
          <div className="topbar-item mr-4">
            <button
              className="btn btn-icon btn-sm btn-clean btn-text-dark-75"
              title="Search"
              onClick={toggleSearch}
            >
              <span className="svg-icon svg-icon-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="7"
                    stroke="#f26722"
                    strokeWidth="2"
                    fill="none"
                  />
                  <line
                    x1="16"
                    y1="16"
                    x2="21"
                    y2="21"
                    stroke="#f26722"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </button>
          </div>

          {/* Department */}
          <div className="topbar-item mr-4">
            <button
              className="btn btn-icon btn-sm btn-clean btn-text-dark-75"
              title="Department Shortcut"
              onClick={toggleDepartment}
            >
              <span className="svg-icon svg-icon-lg">
                {/* 4 block grid icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g fill="#f26722">
                    <rect x="4" y="4" width="7" height="7" rx="1.5" />
                    <rect x="4" y="13" width="7" height="7" rx="1.5" />
                    <rect x="13" y="4" width="7" height="7" rx="1.5" />
                    <rect x="13" y="13" width="7" height="7" rx="1.5" />
                  </g>
                </svg>
              </span>
            </button>
          </div>

          {/* Microapps */}
          <div className="topbar-item mr-4">
            <button
              className="btn btn-icon btn-sm btn-clean btn-text-dark-75"
              title="Microapps"
              onClick={toggleMicroapps}
            >
              <span className="svg-icon svg-icon-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g fill="#f26722">
                    <path d="M10.5,5 L19.5,5 C20.33,5 21,5.67 21,6.5 C21,7.33 20.33,8 19.5,8 L10.5,8 C9.67,8 9,7.33 9,6.5 C9,5.67 9.67,5 10.5,5 Z" />
                    <path d="M10.5,10 L19.5,10 C20.33,10 21,10.67 21,11.5 C21,12.33 20.33,13 19.5,13 L10.5,13 C9.67,13 9,12.33 9,11.5 C9,10.67 9.67,10 10.5,10 Z" />
                    <path d="M10.5,15 L19.5,15 C20.33,15 21,15.67 21,16.5 C21,17.33 20.33,18 19.5,18 L10.5,18 C9.67,18 9,17.33 9,16.5 C9,15.67 9.67,15 10.5,15 Z" />
                    <circle cx="5.5" cy="6.5" r="1.5" />
                    <circle cx="5.5" cy="11.5" r="1.5" />
                    <circle cx="5.5" cy="16.5" r="1.5" />
                  </g>
                </svg>
              </span>
            </button>
          </div>

          {/* Profile */}
          <div className="topbar-item">
            <button
              className="btn btn-icon btn-sm btn-clean"
              title="User"
              onClick={toggleProfile}
            >
              <img
                src={
                  user?.profile_pic
                    ? `${API_BASE_URL.replace("/index.php", "")}/${user.profile_pic}`
                    : "/assets/media/users/default.jpg"
                }
                alt="User"
                className="rounded-circle"
                style={{
                  width: "36px",
                  height: "36px",
                  objectFit: "cover",
                  border: "1px solid orange",
                }}
              />
            </button>
          </div>
        </div>

        {/* ✅ Mobile Profile (only show on small screen) */}
        <div className="d-flex d-md-none">
          <button
            className="btn btn-icon btn-sm btn-clean"
            title="User"
            onClick={toggleProfile}
          >
            <img
              src={
                user?.profile_pic
                  ? `${API_BASE_URL.replace("/index.php", "")}/${user.profile_pic}`
                  : "/assets/media/users/default.jpg"
              }
              alt="User"
              className="rounded-circle"
              style={{
                width: "36px",
                height: "36px",
                objectFit: "cover",
                border: "1px solid orange",
              }}
            />
          </button>
        </div>
      </div>

      {showSearch && (
        <div
          className="position-fixed w-100 px-4 pb-3 pt-3 bg-white"
          style={{
            zIndex: 1040,
            bottom: "60px", // push above bottom nav
            left: 0,
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <div className="d-flex align-items-center">
            <input
              type="text"
              className="form-control form-control-md"
              placeholder="Search Leads By Any Keyword..."
              autoFocus
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleGlobalSearch();
                }
              }}
            />

          </div>
        </div>
      )}

      {showDepartment && (
        <div
          className="position-fixed top-0 left-0 w-100 h-100 d-flex justify-content-end"
          style={{ zIndex: 1050, background: "rgba(0,0,0,0.4)" }}
          onClick={toggleDepartment}
        >
          {/* Right Slide Panel */}
          <div
            className="bg-white animate__animated animate__slideInRight"
            style={{
              width: "85%",
              maxWidth: "360px",
              height: "100%",
              boxShadow: "-2px 0 8px rgba(0,0,0,0.1)",
              borderTopLeftRadius: "1rem",
              borderBottomLeftRadius: "1rem",
              overflowY: "auto", // ✅ Enables scroll
              overscrollBehavior: "contain", // ✅ Prevents background scroll
              padding: "1.5rem",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="font-weight-bold mb-0">All Departments</h5>
              <button
                className="btn btn-sm btn-light"
                onClick={toggleDepartment}
              >
                <i className="la la-times text-dark"></i>
              </button>
            </div>

            {/* Department Grid */}
            <div className="row">
              <div className="row">
                {visibleDepartments.map((dept, i) => (
                  <div className="col-6 mb-4" key={i}>
                    <Link
                      to={`/pages/${dept.id}/${dept.title}`}
                      className="btn btn-block btn-light text-dark-50 text-center py-10 px-5 department-card pt-4"
                      style={{
                        borderRadius: "1rem",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      <i className={`${dept.icon} fa-2x mb-3 text-primary`}></i>
                      <div className="font-weight-bold font-size-h6">
                        {dept.title}
                      </div>
                    </Link>
                  </div>
                ))}
              </div>

              {/* You can add more departments below with the same structure */}
            </div>
          </div>
        </div>
      )}

      {showMicroapps && (
        <div
          className="position-fixed top-0 left-0 w-100 h-100 d-flex justify-content-end"
          style={{ zIndex: 1050, background: "rgba(0,0,0,0.4)" }}
          onClick={toggleMicroapps}
        >
          <div
            className="bg-white animate__animated animate__slideInRight"
            style={{
              width: "85%",
              maxWidth: "360px",
              height: "100%",
              padding: "1.5rem",
              boxShadow: "-2px 0 8px rgba(0,0,0,0.1)",
              borderTopLeftRadius: "1rem",
              borderBottomLeftRadius: "1rem",
              overflowY: "auto", // ✅ enables scroll
              overscrollBehavior: "contain", // ✅ avoids body scroll chaining
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="font-weight-bold mb-0">All Microapps</h5>
              <button
                className="btn btn-sm btn-light"
                onClick={toggleMicroapps}
              >
                <i className="la la-times text-dark"></i>
              </button>
            </div>

            {/* Search */}
            <div className="form-group mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search Microapp..."
                autoFocus
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ fontSize: "0.95rem" }}
              />
            </div>

            {/* Accordion */}
            <div id="microappAccordion">
              {visibleDepartments
                .filter((dept) =>
                  dept.apps.some((app) =>
                    app.label.toLowerCase().includes(searchTerm.toLowerCase()),
                  ),
                )
                .map((dept) => {
                  const isOpen = openDepartments[dept.id] || false;
                  const filteredApps = dept.apps.filter((app) =>
                    app.label.toLowerCase().includes(searchTerm.toLowerCase()),
                  );

                  return (
                    <div key={dept.id} className="mb-3 border-bottom pb-2">
                      <button
                        className="btn btn-light d-flex align-items-center w-100 text-left font-weight-bold px-3 py-3"
                        onClick={() =>
                          setOpenDepartments((prev) => ({
                            ...prev,
                            [dept.id]: !prev[dept.id],
                          }))
                        }
                        style={{ borderRadius: 8 }}
                      >
                        <i
                          className="fas fa-chevron-right"
                          style={{
                            color: "#f26722",
                            transition: "transform 0.2s ease",
                            transform: isOpen
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                            fontSize: "0.75rem",
                            marginRight: 12,
                          }}
                        />
                        <i
                          className={dept.icon}
                          style={{
                            color: "#f26722",
                            fontSize: "1rem",
                            marginRight: 12,
                          }}
                        />
                        <span className="text-dark">{dept.title}</span>
                      </button>

                      <div
                        className="pl-4 pt-2"
                        style={{
                          maxHeight: isOpen ? "500px" : "0",
                          overflow: "hidden",
                          transition: "max-height 0.3s ease-in-out",
                        }}
                      >
                        {filteredApps.length > 0 ? (
                          filteredApps.map((item, idx) => (
                            <Link
                              to={item.link}
                              key={idx}
                              className="d-block py-2 px-2 text-dark font-size-sm rounded"
                              style={{
                                borderLeft: "3px solid #f26722",
                                marginBottom: "4px",
                                transition: "background 0.2s",
                                textDecoration: "none",
                                color: "#000",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background = "#f9f9f9")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background = "white")
                              }
                            >
                              {item.label}
                            </Link>
                          ))
                        ) : (
                          <div className="text-muted small px-2">
                            No matching microapps
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}

      {showProfile && (
        <div
          className="position-fixed top-0 left-0 w-100 h-100 d-flex justify-content-end"
          style={{ zIndex: 1050, background: "rgba(0,0,0,0.4)" }}
          onClick={toggleProfile}
        >
          <div
            className="bg-white animate__animated animate__slideInRight"
            style={{
              width: "85%",
              maxWidth: "360px",
              height: "100%",
              padding: "1.5rem",
              boxShadow: "-2px 0 10px rgba(0,0,0,0.1)",
              borderTopLeftRadius: "1rem",
              borderBottomLeftRadius: "1rem",
              overflowY: "auto", // ✅ scroll enabled
              overscrollBehavior: "contain", // ✅ prevent background scroll chaining
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="font-weight-bold mb-0">Profile</h5>
              <button className="btn btn-sm btn-light" onClick={toggleProfile}>
                <i className="la la-times text-dark"></i>
              </button>
            </div>

            {/* Profile Info */}
            <div
              className="text-center p-5"
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "2rem",
                background: "#fff",
                boxShadow: "0 4px 10px rgba(0,0,0,0.04)",
                maxWidth: "320px",
                margin: "0 auto",
              }}
            >
              {/* Profile Image */}
              <div
                className="d-flex justify-content-center align-items-center mb-4"
                style={{
                  width: 100,
                  height: 100,
                  backgroundColor: "#FFD94D",
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "0 auto",
                }}
              >
                <img
                  src={
                    user?.profile_pic
                      ? `${API_BASE_URL.replace("/index.php", "")}/${user.profile_pic}`
                      : "/assets/media/users/default.jpg"
                  }
                  alt="User"
                  className="rounded-circle"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    border: "1px solid orange",
                  }}
                />
              </div>

              {/* Name */}
              <div className="font-weight-bold text-dark font-size-h6 mb-1">
                {user?.name || "Webyappy Admin"}
              </div>

              {/* Email */}
              <div className="d-flex justify-content-center align-items-center text-muted font-size-sm mb-4">
                <i
                  className="fas fa-envelope text-danger"
                  style={{ marginRight: "0.4rem", fontSize: "0.9rem" }}
                ></i>
                {user?.email || "admin@webyappy.com"}
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-center gap-2">
                <button
                  className="btn btn-sm font-weight-bold text-white"
                  style={{
                    backgroundColor: "#c084fc",
                    padding: "0.2rem 1.2rem",
                    borderRadius: "6px",
                    flex: 1,
                  }}
                  onClick={handleLogout}
                >
                  Sign Out
                </button>

                <Link
                  to="/pages/settings/reset-password"
                  className="btn btn-sm btn-outline-warning font-weight-bold"
                  style={{
                    padding: "0.2rem 1.2rem",
                    borderRadius: "6px",
                    flex: 1,
                    textDecoration: "none",
                  }}
                >
                  Reset Password
                </Link>
              </div>
            </div>

            <div className="separator separator-dashed mb-5 mt-5"></div>

            {/* Quick Options */}
            <div className="navi navi-spacer-x-0 p-0">
              {/* My Profile */}
              <Link
                to="/home/View_emp_details"
                className="navi-item mb-2"
                style={{ textDecoration: "none" }}
              >
                <div className="navi-link rounded shadow-sm py-2 px-3 d-flex align-items-center">
                  <div className="symbol symbol-40 bg-light me-3">
                    <div className="symbol-label">
                      <i className="fas fa-user text-warning"></i>
                    </div>
                  </div>
                  <div className="navi-text">
                    <div className="font-weight-bold text-dark">My Profile</div>
                  </div>
                </div>
              </Link>

              {/* Punch In */}
              <Link
                to="/home/punchin"
                className="navi-item mb-2"
                style={{ textDecoration: "none" }}
              >
                <div className="navi-link rounded shadow-sm py-2 px-3 d-flex align-items-center">
                  <div className="symbol symbol-40 bg-light me-3">
                    <div className="symbol-label">
                      <i className="fas fa-user-check text-success"></i>
                    </div>
                  </div>
                  <div className="navi-text">
                    <div className="font-weight-bold text-dark">Punch In</div>
                  </div>
                </div>
              </Link>

              {/* Punch Out */}
              <Link
                to="/home/punchout"
                className="navi-item mb-2"
                style={{ textDecoration: "none" }}
              >
                <div className="navi-link rounded shadow-sm py-2 px-3 d-flex align-items-center">
                  <div className="symbol symbol-40 bg-light me-3">
                    <div className="symbol-label">
                      <i className="fas fa-sign-out-alt text-danger"></i>
                    </div>
                  </div>
                  <div className="navi-text">
                    <div className="font-weight-bold text-dark">Punch Out</div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Bottom Mobile Nav */}
      <div className="d-md-none fixed-bottom bg-white d-flex justify-content-around p-2 border-top shadow-lg">
        <Link to="/home" className="btn btn-clean text-center text-dark">
          <span className="svg-icon svg-icon-lg d-block mx-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g fill="#f26722">
                <path d="M12 3L2 12h3v9h6v-6h2v6h6v-9h3z" />
              </g>
            </svg>
          </span>
        </Link>

        <button
          className="btn btn-clean text-center text-dark"
          onClick={toggleSearch}
        >
          <span className="svg-icon svg-icon-lg d-block mx-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <circle
                cx="11"
                cy="11"
                r="7"
                stroke="#f26722"
                strokeWidth="2"
                fill="none"
              />
              <line
                x1="16"
                y1="16"
                x2="21"
                y2="21"
                stroke="#f26722"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </span>
          {/* <small>Search</small> */}
        </button>

        <button
          className="btn btn-clean text-center text-dark"
          onClick={toggleDepartment}
        >
          <span className="svg-icon svg-icon-lg d-block mx-auto">
            {/* Department SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g fill="#f26722">
                <rect x="4" y="4" width="7" height="7" rx="1.5" />
                <rect x="4" y="13" width="7" height="7" rx="1.5" />
                <rect x="13" y="4" width="7" height="7" rx="1.5" />
                <rect x="13" y="13" width="7" height="7" rx="1.5" />
              </g>
            </svg>
          </span>
          {/* <small>Dept</small> */}
        </button>

        <button
          className="btn btn-clean text-center text-dark"
          onClick={toggleMicroapps}
        >
          <span className="svg-icon svg-icon-lg d-block mx-auto">
            {/* Microapps SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g fill="#f26722">
                <path d="M10.5,5 L19.5,5 C20.33,5 21,5.67 21,6.5 C21,7.33 20.33,8 19.5,8 L10.5,8 C9.67,8 9,7.33 9,6.5 C9,5.67 9.67,5 10.5,5 Z" />
                <path d="M10.5,10 L19.5,10 C20.33,10 21,10.67 21,11.5 C21,12.33 20.33,13 19.5,13 L10.5,13 C9.67,13 9,12.33 9,11.5 C9,10.67 9.67,10 10.5,10 Z" />
                <path d="M10.5,15 L19.5,15 C20.33,15 21,15.67 21,16.5 C21,17.33 20.33,18 19.5,18 L10.5,18 C9.67,18 9,17.33 9,16.5 C9,15.67 9.67,15 10.5,15 Z" />
                <circle cx="5.5" cy="6.5" r="1.5" />
                <circle cx="5.5" cy="11.5" r="1.5" />
                <circle cx="5.5" cy="16.5" r="1.5" />
              </g>
            </svg>
          </span>
          {/* <small>Apps</small> */}
        </button>
      </div>
    </>
  );
}

export default Header;
